import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import HomePage from "./pages/HomePage";
import Profile from './pages/Profile';
import Builder from './pages/Builder';
import NotFound from './pages/NotFound';
import AuthenticationPage from './pages/AuthPage';
import TermsPage from './pages/TermsPage';
import CheckoutPage from './pages/CheckoutPage';


function App() {
  return (
      <Router>
        <Routes>
          <Route path='/' element={<HomePage />} />
          <Route path='/login' element={<AuthenticationPage/>} />
          <Route path='/account' element={<Profile />} />
          <Route path='/builder' element={<Builder />} />
          <Route path='/checkout' element={<CheckoutPage/>} />
          <Route path='/terms-and-conditions' element={<TermsPage />} />
          <Route path='*' element={<NotFound />} />
        </Routes>
      </Router>
  );
}

export default App;